import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {DocumentRejection} from "../../models/document-rejection";
import Helpers from "../../utils/helpers";

@Injectable()
export class DocumentControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getDocumentRejections(): Observable<DocumentRejection[]> {
    return this.http.get(this.baseUrl + "document/rejection") as Observable<DocumentRejection[]>;
  }

  public saveDocumentRejection(documentRejections: DocumentRejection[]): Observable<DocumentRejection[]> {
    Helpers.trimRecursiveObj(documentRejections);
    const body = JSON.stringify(documentRejections);
    return this.http.post(this.baseUrl + "document/rejection", body) as Observable<DocumentRejection[]>;
  }

}
